import { SectionWrapper } from 'components/atoms/SectionWrapper.style';
import React from 'react';
import FarmImages from 'components/organisms/farmsComponents/farmImages/OfferImages';
import FarmDesc from 'components/organisms/farmsComponents/farmDesc/FarmDesc';
import ScopeTechnical from 'components/organisms/farmsComponents/scopeTechnical/ScopeTechnical';
import TechnicalTeamActivities from 'components/organisms/farmsComponents/technicalTeamActivties/TechnicalTeamActivities';
import ProcesPart from 'components/organisms/farmsComponents/procesPart/ProcesPart';
import FarmGallery from 'components/organisms/farmsComponents/farmGallery/FarmGallery';
import Header from 'components/organisms/header/Header';
import ProjPortofilio from 'components/molecules/Portoflio /ProjPortofilio';

const Offer = () => (
  <>
    <Header />
    <FarmImages />
    <SectionWrapper>
      <FarmDesc />
    </SectionWrapper>
    {/* <ProjPortofilio /> */}
  </>
);

export default Offer;
